export default {
    namespaced: true,
    state: {
		endpoint: 'city/district',
		item: {},
        items: [],
    },
}